/**
 * Purview CVC Details Component
 * Main component that displays Purview CVC Customers dashboard
 */

import React from "react";
import { Icon } from "@fluentui/react";
import { PurviewCVCCustomersTab } from "./PurviewCVCCustomersTab";
import { PURVIEW_CVC_STYLES } from "./PurviewCVC.styles";
import { IPurviewCVCDetailsProps } from "./PurviewCVC.interfaces";

export const PurviewCVCDetails: React.FC<IPurviewCVCDetailsProps> = ({ isLoading = false }) => {
    return (
        <div className={PURVIEW_CVC_STYLES.pageRoot}>
            {/* Page header with logo badge */}
            <div className={PURVIEW_CVC_STYLES.pageHeader}>
                <div className={PURVIEW_CVC_STYLES.headerLeft}>
                    <div className={PURVIEW_CVC_STYLES.headerLogoBadge}>
                        <Icon iconName="Shield" />
                    </div>
                    <div>
                        <div className={PURVIEW_CVC_STYLES.pageHeaderTitle}>Purview CVC Customers — Last 6 Months</div>
                        <div className={PURVIEW_CVC_STYLES.pageHeaderSubtitle}>
                            Built with Copilot · Solution & Customer Tracking · Active within 180 days
                        </div>
                    </div>
                </div>
            </div>

            {/* Purview CVC Customers Content */}
            <PurviewCVCCustomersTab isLoading={isLoading} />
        </div>
    );
};
